const uuidv4 = require('uuid').v4
const { WAREHOUSE_DEFINITIONS } = require('../../order/tools/read/warehouse-code-to-virtual')
const { normalizeProgram } = require('./normalize-program')

const transformWarehouseData = (organisationId, bulkRawStockData, username, options = {}) => {
  const { useOriginalTimestamp = false } = options
  const groupedData = {}

  bulkRawStockData.forEach(rawStockData => {
    const timestamp = useOriginalTimestamp
      ? new Date(rawStockData.created_at)
      : new Date()
    const item = rawStockData.data
    const sku = item.sapCode.trim()

    if (!sku) {
      return null
    }

    // Get UUID from RMS warehouse code
    const warehouseCode = item.valuationArea
    const program = normalizeProgram(item.program)

    const key = `${sku}-${warehouseCode}`

    if (!groupedData[key]) {
      let locationId = null
      if (warehouseCode && WAREHOUSE_DEFINITIONS.RMS && WAREHOUSE_DEFINITIONS.RMS[warehouseCode]) {
        locationId = WAREHOUSE_DEFINITIONS.RMS[warehouseCode].uuid
      }

      groupedData[key] = {
        headerId: uuidv4(),
        locationId,
        organisationId,
        sku,
        warehouseCode,
        date: timestamp,
        totalStock: 0,
        details: []
      }
    }

    const quantity = parseInt(item.totalStock) || 0
    // We aggregate total stock at header level
    // and keep batch details at detail level
    groupedData[key].totalStock += quantity

    groupedData[key].details.push({
      batch: item.batchNumber || 'NOBATCH', // The API also returns NOBATCH
      expiry_date: item.expiryDate,
      program: program,
      quantity: quantity,
      manufacturer: item.manufacturer || 'UNKNOWN'
    })
  })

  return Object.values(groupedData).map(group => {
    return {
      id: group.headerId,
      location_id: group.locationId,
      organisation_id: group.organisationId,
      sku: group.sku,
      date: group.date,
      closing: group.totalStock,
      source: group.warehouseCode,
      created_at: group.date,
      updated_at: group.date,
      created_by: username,
      updated_by: username,

      _details: group.details.map(d => ({
        stock_event_id: group.headerId,
        batch: d.batch,
        expiry_date: d.expiry_date,
        program: d.program,
        quantity: d.quantity,
        manufacturer: d.manufacturer,
        created_at: group.date,
        updated_at: group.date
      }))
    }
  })
}

module.exports = { transformWarehouseData }
